<template>
     <div class="title-show common-title-style">
        <span class="title">{{title}}</span>
        <span class="see-more mouse-style" v-if="!liveDetail && data && (data.wbsLiveLibraryVos && data.wbsLiveLibraryVos.length)" @click.stop="jumpMore">查看更多  ></span>
        <span class="see-more mouse-style" v-if="data && liveDetail" @click.stop="jumpMore">查看更多  ></span>
      </div>
</template>
<script>
export default {
  props: ['title', 'index', 'data', 'liveDetail'],
  methods: {
    jumpMore () {
      this.$emit('lookMore')
    }
  }
}
</script>
<style scoped lang="scss">
.title-show{
  display:flex;
  align-items:center;
}
.title-show>.title{
 flex:1;
 text-align:left;
}
.title-show>.see-more{
font-size: 18px;
font-weight: 400;
text-align: right;
color: #187fc3;
line-height: 26px;
font-family: PingFangSC, PingFangSC-Regular;
}
</style>
